import { motion } from "framer-motion";
import { BarChart3, BookOpenCheck, Stethoscope, Users } from "lucide-react";
import { expertise } from "../../data/portfolio";
import { SectionHead } from "./Reveal";

const icons = [BookOpenCheck, BarChart3, Stethoscope, Users];

export default function Expertise() {
  return (
    <section id="expertise" data-testid="expertise-section" className="relative py-28 md:py-40 bg-[#F2F2EF]/60 overflow-hidden">
      <div className="absolute rounded-full mix-blend-multiply blur-3xl opacity-50 bg-sage w-[26rem] h-[26rem] -top-24 left-1/4 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <SectionHead eyebrow="Areas of expertise" title={<>A toolkit built<br />across two worlds.</>} testid="expertise-heading" />
        <div className="grid grid-cols-1 md:grid-cols-4 gap-5 md:gap-6">
          {expertise.map((area, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={area.title}
                data-testid={`expertise-card-${i}`}
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.85, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 }}
                className={`glass glass-hover p-8 md:p-9 ${area.span}`}
              >
                <div className="w-11 h-11 rounded-2xl bg-sage/40 border border-white/60 flex items-center justify-center mb-7">
                  <Icon className="w-5 h-5 text-ink/70" strokeWidth={1.5} />
                </div>
                <h3 className="font-display text-xl md:text-2xl font-medium tracking-tight text-ink">{area.title}</h3>
                <div className="mt-5 flex flex-wrap gap-2">
                  {area.tags.map((t) => (
                    <span key={t} className="pill-tag">{t}</span>
                  ))}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
